
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import icon1 from "../../assets/icons/Layer-1.png";
import icon2 from "../../assets/icons/Layer-2.png";
import icon3 from "../../assets/icons/Layer-3.png";
import icon4 from "../../assets/icons/Asset-4.png";
import { useLanguage } from "../../store/language-context";
import { useTranslation } from "react-i18next";

const StatsCard = () => {
  const { URL } = useLanguage();
  const { t } = useTranslation();
  const [statsData, setStatsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [description, setDescription] = useState("");
  const hasAnimated = useRef(false); // Prevent multiple animations

  useEffect(() => {
    const fetchStatsData = async () => {
      setIsLoading(true)
      try {
        const response = await axios.get(
          `${URL}/home-pages?title_section=ivory_numbers`
        );
        if (response.data.status === 200) {
          const data = response.data.data.data;
          const description = response.data.data.description || "";
          setStatsData(
            data.map((item) => ({
              ...item,
              animatedNumber: 0, 
            }))
          );
          setDescription(stripHtml(description));
        }
      } catch (error) {
        console.error("Error fetching stats data:", error);
      } finally {
        setIsLoading(false)
      }
    };
    fetchStatsData();
  }, [URL]);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasAnimated.current && window.scrollY > 1000) {
        hasAnimated.current = true; // Prevent multiple animations
        statsData.forEach((item, index) => {
          animateNumber(index, parseInt(item.sub_title, 10));
        });
        window.removeEventListener("scroll", handleScroll); // Remove event listener after animation starts
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [statsData]);

  const animateNumber = (index, targetNumber) => {
    const duration = 3000; // 3 seconds
    const interval = 10; // Smooth transition
    const steps = duration / interval;
    const increment = targetNumber / steps;

    const counter = setInterval(() => {
      setStatsData((prevData) => {
        const newData = [...prevData];

        // Increase number to target
        if (newData[index].animatedNumber < targetNumber) {
          newData[index].animatedNumber = Math.min(
            newData[index].animatedNumber + increment,
            targetNumber
          );
        } else {
          clearInterval(counter); // Stop animation at the target number
        }

        return newData;
      });
    }, interval);
  };

  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  if (statsData.length === 0 && !isLoading) {
    return (
      <div className="text-center">
        {t('custom.err')}
      </div>
    );
  }
  const icons = [icon1,icon2,icon3,icon4]


  return (
    <div style={styles.statscard}>
      <div style={styles.container} className="container">
        <h2 style={styles.title} className="section-title h-1">
          {t('home.ivory-numbers')}
        </h2>
        {description && <p style={styles.description}>{description}</p>}
        <div style={styles.stat} className="flex justify-between items-start max-lg:grid max-lg:grid-cols-2 max-md:grid-cols-1 gap-3">
          {
            isLoading ?
              <>
                {
                  [...Array(4)].map((_, i) => (
                    <div key={i} className="grid place-items-center gap-2 my-3">
                      <div className="h-24 w-20 l-load-dt rounded-md"></div>
                      <div className="h-6 w-28 l-load-dt rounded-md"></div>
                    </div>
                  ))
                }
              </>
              :
              <>
                {statsData.map((item, i) => (
                  <div
                    key={item.id || i}
                    style={styles.stat}
                    className="col-lg-2 number-part col-md-5 grid justify-items-center"
                  >
                    <div style={styles.iconWrapper}>
                      <img src={icons[i]} alt={item.title} style={styles.icon} />
                    </div>
                    <h3 style={styles.number}>{Math.floor(item.animatedNumber)}</h3>
                    <p style={styles.label}>{item.title}</p>
                  </div>
                ))}
              </>
          }
        </div>
      </div>
    </div>
  );
};

const styles = {
  statscard: {
    background: "#6A2F38",
    color: "#fff",
    padding: "20px 20px",
    textAlign: "center",
  },
  container: {
    margin: "0 auto",
  },
  stat: {

    margin: "  10px",
    padding: "10px",
    color: "#9b1c2d",
    borderRadius: "8px",
    textAlign: "center",
  },
  number: {
    fontSize: "1.4rem",
    marginTOP: "5px",
    color: "#D4AD89",
    fontWeight: "bold",
    transition: "ease-in-out 0.5s",
  },
  label: {
    marginBottom: "0",
    fontSize: "1.2rem",
    color: "#fff",
  },
  description: {
    marginBottom: "0px",
    fontSize: "20px",
  },
  iconWrapper: {
    marginBottom: "10px",
  },
  icon: {},
};

export default StatsCard;